import React from 'react';

import { Button } from '@mui/material';

import { angularizeWithProviders } from '../../providers';
import { ErrorState } from '../../components/ErrorState/ErrorState';
import { goToHomePage } from '../../utils/angularUtils';
import { SolutionType } from '../../constants/user-info/solutionType';
import { getHumanizeSolutionType } from '../../utils/userInfoUtils/getHumanizeSolutionType/getHumanizeSolutionType';

type UnavailableSolutionErrorProps = {
  activeSolution: SolutionType | null;
};

const UnavailableSolutionError = ({ activeSolution }: UnavailableSolutionErrorProps) => {
  const solutionName = activeSolution
    ? getHumanizeSolutionType(activeSolution)
    : 'this solution';

  return (
    <ErrorState
      title="We couldn't find this page"
      description={`This page does not exist in ${solutionName}, please go to the main page`}
    >
      <Button variant="contained" onClick={goToHomePage}>
        Return to the Main Page
      </Button>
    </ErrorState>
  );
};

angularizeWithProviders(UnavailableSolutionError, 'ngzUnavailableSolutionError', {
  activeSolution: '<',
});

export { UnavailableSolutionError };
